import { observable, action, set } from 'mobx';

export interface IGeoLocation {
    lat: number;
    lng: number;
}

export interface IUserLocation {
    geolocation: IGeoLocation;
    country?: string;
    city?: string;
    zipcode: string;
}

export class UserLocation {
    @observable public geolocation: IGeoLocation;
    @observable public country: string;
    @observable public city: string;
    @observable public zipcode: string;

    constructor(item: Partial<IUserLocation>) {
        this.update(item);
    }

    @action
    public update(item: Partial<IUserLocation>) {
        set(this, item);

        return this;
    }
}
